// extracted by mini-css-extract-plugin
export default {"titleRow":"Header_titleRow__OuTxX"};